import {Type} from '@angular/core';
import * as _ from 'lodash-es';
import {Bin} from './bin';
import {Board} from './board';
import {BinPlacementState} from './common/bin-placement-state';
import {PlaceFinder} from './common/place-finder';
import {PlacedBinDef} from './common/placed-bin-def';
import {ScoreCalculator} from './common/score-calculator';
import {BasicPlaceFinder} from './place-finders/basic-place-finder';
import {OverlappingPlaceFinder} from './place-finders/overlapping-place-finder';
import {ParentCenterPlaceFinder} from './place-finders/parent-center-place-finder';
import {PlacedBin} from './placed-bin';
import {CenteringScoreCalculator} from './score-calculators/centering-score-calculator';
import {CompactnessScoreCalculator} from './score-calculators/compactness-score-calculator';
import {OrientationScoreCalculator} from './score-calculators/orientation-score-calculator';
import {OverlappingScoreCalculator} from './score-calculators/overlapping-score-calculator';

export class FloatPlacement {

    public board: Board;
    public placedBins: PlacedBin[];

    public placeFinderTypes: Array<Type<PlaceFinder>> = [
        ParentCenterPlaceFinder,
        BasicPlaceFinder,
        OverlappingPlaceFinder
    ];

    public scoreCalculatorTypes: Array<Type<ScoreCalculator>> = [
        OverlappingScoreCalculator,
        OrientationScoreCalculator,
        CompactnessScoreCalculator,
        CenteringScoreCalculator
    ];

    public initBoard(w: number, h: number, binsGap: number): FloatPlacement {
        this.board = new Board(w, h, binsGap);

        return this;
    }

    public initBins<T>(objects: T[], placedBinDefFactory: (object: T) => PlacedBinDef): FloatPlacement {
        this.placedBins = objects
            .map(obj => placedBinDefFactory(obj))
            .map(placedBinDef => PlacedBin.createFromDef(placedBinDef, this.board));

        return this;
    }

    public produceVariants(bin: Bin): BinPlacementState[] {
        const finders: PlaceFinder[] = this.placeFinderTypes.map(Finder =>
            new Finder(this.board, this.placedBins, bin)
        );

        const calculators: ScoreCalculator[] = this.scoreCalculatorTypes.map(Calculator =>
            new Calculator(this.board, this.placedBins)
        );

        const getScore = (placedBin: PlacedBin): string => this.encodeScore(
            calculators.map(calculator => calculator.calc(placedBin))
        );

        const variants: BinPlacementState[] = finders.reduce(
            (stack, finder): PlacedBin[] => stack.concat(finder.produceVariants()),
            []
        )
            .map((placedBin: PlacedBin) => new BinPlacementState(
                placedBin,
                getScore(placedBin)
            ))
            .sort((v1, v2) => v2.score.localeCompare(v1.score));

        return variants;
    }

    private encodeScore(scoreValues: number[]): string {
        const ENCODING_RADIX = 36;
        const SCORE_ITEM_LENGTH = 2;

        return scoreValues
            .map(value => _.padStart(value.toString(ENCODING_RADIX), SCORE_ITEM_LENGTH, '0'))
            .join('');
    }

}
